import { useEffectReducer } from 'use-effect-reducer'
import { useTrackLSPAYError, TAG } from '../errorTracking'
import { getCardNotPresentPaymentEffectsMap } from './effects'
import { cardNotPresentPaymentStateReducer } from './reducer'
import {
  CardNotPresentPaymentReducerArgs,
  CardNotPresentPaymentState,
} from './types'

export const useCardNotPresentEffectReducer = (
  args: CardNotPresentPaymentReducerArgs
) => {
  const { transactionId, trackTiming } = args

  const trackError = useTrackLSPAYError(TAG.cardNotPresentPayment, {
    transactionId,
  })

  return useEffectReducer(
    cardNotPresentPaymentStateReducer,
    // initial state
    exec => {
      exec({
        type: 'fetchCNPConfigEffect',
      })
      return {
        status: 'fetchingCNPConfig',
        clientSecret: args.intentClientSecret,
      } as CardNotPresentPaymentState
    },
    getCardNotPresentPaymentEffectsMap({ ...args, trackError, trackTiming })
  )
}
